/* ============================================================
   Lunira theme — UI logic + Shopify AJAX cart
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Money formatting (Shopify) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || window.moneyFormat || '{{amount}}';
    var out = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(val, def) { return (val == null || isNaN(val)) ? def : val; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch (fmt.match(placeholderRegex)[1]) {
      case 'amount': out = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': out = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': out = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': out = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = formatWithDelimiters(cents, 0, ' '); break;
      default: out = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, out);
  }

  /* checkout.js formats the same prices — share one implementation */
  window.formatMoney = formatMoney;

  function routes() { return window.routes || {}; }

  /* ============================================================
     MENU
     ============================================================ */
  window.openMenu = function () {
    var m = document.getElementById('menu');
    if (m) { m.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window.closeMenu = function () {
    var m = document.getElementById('menu');
    if (m) { m.classList.remove('open'); document.body.style.overflow = ''; }
  };

  /* ============================================================
     SHOPIFY CART (AJAX)
     ============================================================ */
  function setLoading(on) {
    var b = document.getElementById('buy-btn');
    if (b) b.classList.toggle('is-loading', !!on);
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    if (body) {
      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-empty">Tvoja korpa je prazna.</div>';
      } else {
        body.innerHTML = cart.items.map(function (item) {
          var sub = item.variant_title && item.variant_title.indexOf('Default') === -1
            ? '<div class="cart-item-sub">' + item.variant_title + '</div>' : '';
          var img = item.image
            ? '<img class="cart-item-img" src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '">' : '';
          return '<div class="cart-item" data-line-key="' + item.key + '">'
            + img
            + '<div class="cart-item-info">'
            + '<div class="cart-item-name">' + item.product_title + '</div>'
            + sub
            + '<div class="cart-item-ctrl">'
            + '<div class="cart-qty">'
            + '<button onclick="cartChange(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Manje">−</button>'
            + '<span>' + item.quantity + '</span>'
            + '<button onclick="cartChange(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Više">+</button>'
            + '</div>'
            + '<button class="cart-item-remove" onclick="cartChange(\'' + item.key + '\',0)">Ukloni</button>'
            + '</div></div>'
            + '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>'
            + '</div>';
        }).join('');
      }
    }
    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    /* the CTA is a <button> for the native checkout, an <a> for the custom page */
    var co = document.getElementById('cart-checkout');
    if (co) {
      var empty = cart.item_count === 0;
      if (co.tagName === 'A') {
        co.classList.toggle('is-disabled', empty);
        co.setAttribute('aria-disabled', empty ? 'true' : 'false');
      } else {
        co.disabled = empty;
      }
    }

    var badge = document.getElementById('cart-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('show', cart.item_count > 0);
    }
  }

  function fetchCart() {
    return fetch(routes().cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  window.cartChange = function (key, quantity) {
    fetch(routes().cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        /* the checkout page listens for this to re-price itself */
        document.dispatchEvent(new CustomEvent('lunira:cart-updated', { detail: cart }));
      });
  };

  window.addToCart = function () {
    var btn = document.getElementById('buy-btn');
    var variantId = window.selectedVariantId
      || (btn && btn.getAttribute('data-variant-id'));
    if (!variantId) return;
    setLoading(true);
    fetch(routes().cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: window.shopCurrency,
            value: (item.price || 0),
            items: [{
              item_id: String(item.variant_id),
              item_name: item.product_title,
              price: (item.price || 0),
              quantity: item.quantity
            }]
          }
        });
        return fetchCart();
      })
      .then(function (cart) { renderCart(cart); openCart(); })
      .catch(function () { /* swallow */ })
      .finally(function () { setLoading(false); });
  };

  window.openCart = function (e) {
    if (e && e.preventDefault) e.preventDefault();
    fetchCart().then(renderCart);
    var ov = document.getElementById('cart-overlay');
    var s = document.getElementById('cart-sheet');
    if (ov) ov.classList.add('open');
    if (s) { s.classList.add('open'); s.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
    return false;
  };
  window.closeCart = function () {
    var ov = document.getElementById('cart-overlay');
    var s = document.getElementById('cart-sheet');
    if (ov) ov.classList.remove('open');
    if (s) { s.classList.remove('open'); s.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  };

  /* Bundle / variant picker on product page */
  window.pickBundle = function (el) {
    document.querySelectorAll('.bundle-opt').forEach(function (o) { o.classList.remove('active'); });
    el.classList.add('active');
    window.selectedVariantId = el.getAttribute('data-variant-id');
    var price = parseInt(el.getAttribute('data-price'), 10);
    var btn = document.getElementById('buy-btn');
    if (btn && !isNaN(price)) {
      btn.setAttribute('data-variant-id', window.selectedVariantId);
      console.log(price);
      if(price > 0) {
        btn.textContent = 'NARUČI — ' + formatMoney(price*100);
      } else {
        btn.textContent = 'NARUČI — ' + formatMoney(price);
      }

    }
  };

  /* ============================================================
     PRODUCT GALLERY
     ============================================================ */
  var cur = 0, athCur = 0, total = 0, athTotal = 0;

  window.heroNav = function (d) {
    goSlide(Math.max(0, Math.min(total - 1, cur + d)));
  };
  function goSlide(i) {
    var slide = document.querySelector('.slide');
    if (!slide) return;
    cur = i;
    var w = slide.offsetWidth + 12;
    var track = document.getElementById('track');
    if (track) track.style.transform = 'translateX(-' + (i * w) + 'px)';
    var gp = document.querySelector('.g-prev'), gn = document.querySelector('.g-next');
    if (gp) { if (i <= 0) gp.setAttribute('disabled', ''); else gp.removeAttribute('disabled'); }
    if (gn) { if (i >= total - 1) gn.setAttribute('disabled', ''); else gn.removeAttribute('disabled'); }
    document.querySelectorAll('.slide-dots .dot').forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
    document.querySelectorAll('.gallery-wrap .slide-thumb').forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
  }
  window.goAth = function (i) {
    var s = document.querySelector('.ath-slide');
    if (!s) return;
    athCur = i;
    var w = s.offsetWidth + 12;
    var track = document.getElementById('ath-track');
    if (track) track.style.transform = 'translateX(-' + (i * w) + 'px)';
    document.querySelectorAll('.sec-athletes .dot').forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
  };

  function attachSwipe(viewport, track, getIndex, setIndex, getTotal, getSlideWidth) {
    if (!viewport || !track) return;
    var startX = 0, startY = 0, currentX = 0, startTime = 0;
    var dragging = false, locked = false, axisDecided = false, baseOffset = 0;
    var origTransition = track.style.transition;
    function onStart(e) {
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; currentX = startX;
      startTime = Date.now();
      dragging = true; locked = false; axisDecided = false;
      baseOffset = -getIndex() * getSlideWidth();
      track.style.transition = 'none';
    }
    function onMove(e) {
      if (!dragging) return;
      var t = e.touches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (!axisDecided) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) { axisDecided = true; locked = Math.abs(dx) > Math.abs(dy); }
      }
      if (!locked) return;
      if (e.cancelable) e.preventDefault();
      currentX = t.clientX;
      var move = currentX - startX;
      var idx = getIndex(), tot = getTotal();
      if ((idx === 0 && move > 0) || (idx === tot - 1 && move < 0)) move = move * 0.35;
      track.style.transform = 'translateX(' + (baseOffset + move) + 'px)';
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = origTransition || 'transform 0.42s cubic-bezier(0.4,0,0.2,1)';
      if (!locked) { setIndex(getIndex()); return; }
      var dx = currentX - startX;
      var dt = Math.max(1, Date.now() - startTime);
      var velocity = dx / dt;
      var w = getSlideWidth();
      var idx = getIndex(), tot = getTotal();
      var target = idx;
      if (Math.abs(dx) > w * 0.25 || Math.abs(velocity) > 0.3) {
        target = dx < 0 ? Math.min(idx + 1, tot - 1) : Math.max(idx - 1, 0);
      }
      setIndex(target);
    }
    viewport.addEventListener('touchstart', onStart, { passive: true });
    viewport.addEventListener('touchmove', onMove, { passive: false });
    viewport.addEventListener('touchend', onEnd, { passive: true });
    viewport.addEventListener('touchcancel', onEnd, { passive: true });
  }

  /* ============================================================
     INGREDIENT / FAQ TOGGLES
     ============================================================ */
  window.toggleIng = function (card) {
    var o = card.classList.contains('open');
    document.querySelectorAll('.ing-card').forEach(function (c) { c.classList.remove('open'); });
    if (!o) card.classList.add('open');
  };
  window.toggleFaq = function (item) {
    var o = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
    if (!o) item.classList.add('open');
  };

  /* ============================================================
     REVIEWS (static demo data)
     ============================================================ */
  var REVIEWS = window.LUNIRA_REVIEWS || [];
  var REV_PER = 4;
  function pageList(c, t) {
    if (t <= 7) { var a = []; for (var i = 1; i <= t; i++) a.push(i); return a; }
    var left = 2, right = t - 1;
    if (c <= 3) { left = 2; right = 4; }
    else if (c >= t - 2) { left = t - 3; right = t - 1; }
    else { left = c - 1; right = c + 1; }
    var p = [1];
    if (left > 2) p.push('...');
    for (var j = left; j <= right; j++) p.push(j);
    if (right < t - 1) p.push('...');
    p.push(t);
    return p;
  }
  function renderReviews(page) {
    var list = document.getElementById('reviews-list');
    var pag = document.getElementById('rev-pagination');
    if (!list || !pag) return;
    var t = Math.ceil(REVIEWS.length / REV_PER);
    page = Math.max(1, Math.min(page, t));
    var start = (page - 1) * REV_PER, slice = REVIEWS.slice(start, start + REV_PER);
    list.innerHTML = slice.map(function (r) {
      var stars = r[0] >= 5 ? '★★★★★' : '★★★★<span class="rev-star-dim">★</span>';
      var txt = r[1] ? '<div class="rev-text">"' + r[1] + '"</div>' : '';
      return '<div class="rev"><div class="rev-stars">' + stars + '</div>' + txt + '<div class="rev-who">' + r[2] + '</div></div>';
    }).join('');
    var html = '<button class="rev-page-nav"' + (page === 1 ? ' disabled' : '') + ' onclick="gotoReviews(' + (page - 1) + ')" aria-label="Prethodna">‹</button>';
    pageList(page, t).forEach(function (it) {
      if (it === '...') html += '<span class="rev-ellipsis">…</span>';
      else html += '<button class="rev-page' + (it === page ? ' active' : '') + '" onclick="gotoReviews(' + it + ')">' + it + '</button>';
    });
    html += '<button class="rev-page-nav"' + (page === t ? ' disabled' : '') + ' onclick="gotoReviews(' + (page + 1) + ')" aria-label="Sledeća">›</button>';
    pag.innerHTML = html;
  }
  window.gotoReviews = function (p) { renderReviews(p); var s = document.getElementById('reviews'); if (s) s.scrollIntoView({ behavior: 'smooth' }); };
  window.openReviewForm = function () {
    var c = document.getElementById('rev-write-card'); if (c) c.style.display = 'none';
    var w = document.getElementById('rev-form-wrap'); if (w) { w.classList.add('open'); w.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  };
  window.closeReviewForm = function () {
    var w = document.getElementById('rev-form-wrap'); if (w) w.classList.remove('open');
    var c = document.getElementById('rev-write-card'); if (c) c.style.display = 'block';
  };
  window.setRating = function (rating) {
    document.querySelectorAll('.rev-form-star').forEach(function (star, i) { star.classList.toggle('active', i < rating); });
  };
  window.submitReview = function (e) {
    e.preventDefault();
    var w = document.getElementById('rev-form-wrap');
    if (w) w.innerHTML = '<div class="rev-thanks">Hvala na recenziji.<small>Pregledaćemo je i objaviti u narednim danima.</small></div>';
  };

  /* ============================================================
     COUNTERS / ANIMATIONS
     ============================================================ */
  function countUp(el, target, duration, onDone) {
    el.style.opacity = '1';
    var start = 0, step = target / (duration / 50);
    var interval = setInterval(function () {
      start += step;
      if (start >= target) { el.textContent = target; clearInterval(interval); if (onDone) onDone(); }
      else el.textContent = Math.floor(start);
    }, 50);
  }

  /* ============================================================
     INIT (DOM ready)
     ============================================================ */
  function init() {
    /* Gallery */
    var slides = document.querySelectorAll('.slides-track .slide');
    total = slides.length;
    var athSlides = document.querySelectorAll('.ath-slides-track .ath-slide');
    athTotal = athSlides.length;

    if (total) {
      goSlide(0);
      attachSwipe(
        document.querySelector('.slides-viewport'),
        document.getElementById('track'),
        function () { return cur; },
        function (i) { goSlide(i); },
        function () { return total; },
        function () { return document.querySelector('.slide').offsetWidth + 12; }
      );
    }
    if (athTotal) {
      attachSwipe(
        document.querySelector('.ath-slides-viewport'),
        document.getElementById('ath-track'),
        function () { return athCur; },
        function (i) { goAth(i); },
        function () { return athTotal; },
        function () { return document.querySelector('.ath-slide').offsetWidth + 12; }
      );
    }

    /* Desktop thumbnail strip */
    (function () {
      if (window.innerWidth < 1024) return;
      var galSlides = document.querySelectorAll('.gallery-wrap .slide');
      var gallery = document.querySelector('.gallery-wrap');
      if (!galSlides.length || !gallery || gallery.querySelector('.slide-thumbs')) return;
      var thumbs = document.createElement('div');
      thumbs.className = 'slide-thumbs';
      galSlides.forEach(function (slide, i) {
        var t = document.createElement('button');
        t.className = 'slide-thumb' + (i === 0 ? ' active' : '');
        t.setAttribute('aria-label', 'Slika ' + (i + 1));
        var img = slide.querySelector('img');
        var facts = slide.querySelector('.facts');
        if (img) { var tImg = document.createElement('img'); tImg.src = img.src; tImg.alt = ''; t.appendChild(tImg); }
        else if (facts) {
          t.classList.add('thumb-table');
          var mini = document.createElement('div'); mini.className = 'thumb-mini';
          mini.appendChild(facts.cloneNode(true)); t.appendChild(mini);
        }
        t.addEventListener('click', function () { goSlide(i); });
        thumbs.appendChild(t);
      });
      gallery.appendChild(thumbs);
    })();

    /* Reviews */
    renderReviews(1);

    /* Default selected variant on product page */
    var firstBundle = document.querySelector('.bundle-opt.active') || document.querySelector('.bundle-opt');
    if (firstBundle) {
      window.selectedVariantId = firstBundle.getAttribute('data-variant-id');
      var btn = document.getElementById('buy-btn');
      if (btn) btn.setAttribute('data-variant-id', window.selectedVariantId);
    }

    /* Reveal-on-scroll (home) */
    (function () {
      var els = document.querySelectorAll('.rv');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: .12 });
      els.forEach(function (e) { io.observe(e); });
    })();

    /* Home product carousel dashes */
    (function () {
      var c = document.getElementById('crs');
      var ds = document.querySelectorAll('#dashes .dash');
      if (!c || !ds.length) return;
      function stepW() { return c.children[0].getBoundingClientRect().width + 14; }
      c.addEventListener('scroll', function () {
        var i = Math.min(Math.round(c.scrollLeft / stepW()), ds.length - 1);
        ds.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }, { passive: true });
    })();

    /* Survey count-up */
    (function () {
      var sec = document.getElementById('sec-survey');
      if (!sec || !('IntersectionObserver' in window)) return;
      function animateNum(el, target, duration) {
        var startTime = null;
        function stepFn(ts) {
          if (!startTime) startTime = ts;
          var p = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(stepFn); else el.textContent = target;
        }
        requestAnimationFrame(stepFn);
      }
      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !fired) {
            fired = true;
            sec.querySelectorAll('.pct-num').forEach(function (n, i) {
              var target = parseInt(n.getAttribute('data-target'), 10) || 0;
              setTimeout(function () { animateNum(n, target, 2600); }, 80 + i * 120);
            });
            io.disconnect();
          }
        });
      }, { threshold: 0.35 });
      io.observe(sec);
    })();

    /* All-in count-up */
    (function () {
      var sec = document.querySelector('.sec-allin');
      if (!sec) return;
      var target = sec.querySelector('.allin-visual') || sec;
      if (!('IntersectionObserver' in window)) { sec.classList.add('in'); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('in'); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(target);
    })();

    /* Timeline dim */
    (function () {
      var rows = document.querySelectorAll('.tl-mobile .tl-row');
      if (!rows.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      rows.forEach(function (r, i) { if (i > 0) r.classList.add('tl-dim'); });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('tl-dim', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -50% 0px', threshold: 0.1 });
      rows.forEach(function (r, i) { if (i > 0) io.observe(r); });
    })();

    /* Sticky CTA */
    (function () {
      var stickyCta = document.getElementById('sticky-cta');
      var triggerEl = document.querySelector('.sec-athletes');
      if (!stickyCta || !triggerEl) return;
      var footerEl = document.querySelector('.site-footer');
      window.addEventListener('scroll', function () {
        var rect = triggerEl.getBoundingClientRect();
        var footerVisible = footerEl && footerEl.getBoundingClientRect().top < window.innerHeight;
        if (rect.top < window.innerHeight && !footerVisible) {
          stickyCta.classList.add('visible'); stickyCta.setAttribute('aria-hidden', 'false');
        } else {
          stickyCta.classList.remove('visible'); stickyCta.setAttribute('aria-hidden', 'true');
        }
      }, { passive: true });
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
